import { useState, useEffect } from "react";
import { message } from "antd";
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";
import { JobApplicationStatusEnum } from "Constants/Enums/JobApplicantStatusEnum";

export default function FeedBack(jobPostingId) {
  const [openfeedback, setOpenfeedback] = useState(false);
  const [feedbackEmployeeId, setFeedBackEmployeeId] = useState(null);
  const [feedbacks, setFeedbacks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!jobPostingId) return;
    fetchApplicants(jobPostingId);
  }, [jobPostingId]);

  const fetchApplicants = async (id) => {
    try {
      const response = await axiosInstance.get(API.hiringJobApplicant.getListByPosting(id));

      const applicants = response.data.applicants || [];

      const mapped = applicants.map((info) => ({
        key: info.jobApplicantId.toString(),
        jobApplicantId: info.jobApplicantId,
        email: info.email,
        status: info.status,
        emailSent: info.emailSent,
        canGiveFeedback:
          info.status === JobApplicationStatusEnum.Interview ||
          info.status === JobApplicationStatusEnum.FeedbackAdded,
      }));

      setFeedbacks(mapped);
    } catch (error) {
      console.error("Error fetching applicants:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const showfeedbackModal = (jobApplicantId) => {
    setFeedBackEmployeeId(jobApplicantId);
    setOpenfeedback(true);
  };

  const [feedbackData, setFeedbackData] = useState({
    rating: 1,
    communicationSkill: 1,
    technicalAptitude: 1,
    attitudeAndMotivation: 1,
    criticalThinking: 1,
    professionalism: 1,
    organizationalFit: 1,
    suitableForPost: 1,
  });

  const handleSubmitFeedback = async () => {
    try {
      const total = Object.values(feedbackData).reduce((a, b) => a + b, 0);

      const payload = {
        jobApplicantId: feedbackEmployeeId,
        ...feedbackData,
        marksAverage: total / 8,
      };

      await axiosInstance.post(API.hiringInterviews.provideFeedback, payload);

      message.success("Feedback submitted successfully");
      setOpenfeedback(false);
      fetchApplicants(jobPostingId);
    } catch (error) {
      console.error(error);
      message.error("Failed to submit feedback");
    }
  };

  return {
    feedbacks,
    openfeedback,
    setOpenfeedback,
    showfeedbackModal,
    feedbackData,
    setFeedbackData,
    handleSubmitFeedback,
    isLoading,
  };
}
